import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';
import { createSelector } from 'reselect';
import lodash from 'lodash';
import { IPumpingStationPumpType } from '../../../../@types/model/masterData/pumpingStation/pumpType';
import { IRootState } from '../../../../@types/redux';
import { connect } from 'react-redux';
import MasterDataPumpingStationPumpTypeFunctions from '../../../../store/masterData/pumpingStation/pumpType/functions';

interface IPumpingStationPumpTypeSelectorProps {
    value : string;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : string) => void;

    isLoading : boolean;
    pumpTypes : Array<IPumpingStationPumpType>;
}

interface IPumpingStationPumpTypeSelectorState { }

class PumpingStationPumpTypeSelectorComponent extends React.Component<IPumpingStationPumpTypeSelectorProps, IPumpingStationPumpTypeSelectorState> {
    constructor(props : IPumpingStationPumpTypeSelectorProps) {
        super(props);

        this.state = {};
    }

    public componentDidMount() {
        MasterDataPumpingStationPumpTypeFunctions.load();
    }

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : string;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? '');
    };

    private readonly getData = (state : IPumpingStationPumpTypeSelectorState, props : IPumpingStationPumpTypeSelectorProps) => props.pumpTypes;
    private readonly getValue = (state : IPumpingStationPumpTypeSelectorState, props : IPumpingStationPumpTypeSelectorProps) => props.value;
    private readonly getRequired = (state : IPumpingStationPumpTypeSelectorState, props : IPumpingStationPumpTypeSelectorProps) => props.required;

    private readonly getPumpTypes = createSelector([
        this.getData,
    ], (pumpTypes) => pumpTypes.filter(x => x.isActive).map(x => x.name).sort());

    private readonly getPumpTypesForDropdown = createSelector([ 
        this.getRequired, this.getPumpTypes,
    ], (required, pumpTypes) => {
        
        const dropdownData = lodash.map(pumpTypes, (element) => ({ label: element, value: element }));
        
        if (!required) {
            dropdownData.unshift({
                label: 'ALL',
                value: '',
            });
        }

        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([ 
        this.getValue, this.getRequired, this.getPumpTypes,
    ], (value, required, pumpTypes) => {
        if (value) {
            const pumpType = pumpTypes.find(element => element === value);

            if (pumpType) {
                return { label: pumpType, value: pumpType };
            } else {
                return { label: value, value };
            }
        }

        if (!value && !required) {
            return {
                label: 'ALL',
                value: '',
            };
        }

        return null;
    });

    public readonly render = () => {
        const { required, className, disabled } = this.props;

        const dropdownData = this.getPumpTypesForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <FormControl margin={'normal'} fullWidth className={className} disabled={disabled} error={required && !value}>
                <Autocomplete 
                    id={'pumpType'}
                    options={dropdownData}
                    value={value}
                    getOptionSelected={(option, val) => option.value === val.value}
                    getOptionLabel={option => option.label}
                    onChange={this.onChange}
                    disableClearable={required}
                    openOnFocus
                    renderInput={params => <TextField error={required && !value} {...params} fullWidth label={'Pump Type'} />}
                />
                {
                    required && !value &&
                    <FormHelperText error>Required</FormHelperText>
                }
            </FormControl>
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return { 
        isLoading: state.masterData.pumpingStation.pumpType.isLoading,
        pumpTypes: state.masterData.pumpingStation.pumpType.pumpTypes,
    };
};

const PumpingStationPumpTypeSelector = connect(
    mapStateToProps,
)(PumpingStationPumpTypeSelectorComponent);

export default PumpingStationPumpTypeSelector;